"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkflowStep = void 0;
var react_1 = __importDefault(require("react"));
var workflow_1 = require("../providers/workflow");
/**
 * Render a workflow step without having to use conditionals.
 */
function WorkflowStep(props) {
    var id = props.id, children = props.children;
    var currentStep = (0, workflow_1.useWorkflowContext)().currentStep;
    if (id === currentStep) {
        return react_1.default.createElement(react_1.default.Fragment, null, children);
    }
    return null;
}
exports.WorkflowStep = WorkflowStep;
